import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

const scrollbarStyles = (theme: Theme) => ({
  '&::-webkit-scrollbar': {
    backgroundColor: theme.palette.background.default,
    scrollbarWidth: 'thin' as const,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.background.paper,
    outline: `1px solid ${theme.palette.divider}`,
  },
  '&::-webkit-scrollbar-thumb': {
    maxWidth: '4px',
    backgroundColor: theme.palette.grey[500],
    borderRadius: '10px',
    border: `2px solid ${theme.palette.background.paper}`,
  },
});

export const useChatContainerStyles = makeStyles((theme: Theme) => ({
  contentWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    transition: 'margin-right 0.3s ease',
    justifyContent: 'center',
    backgroundColor:
      theme.palette?.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray25)'
        : 'var(--xlrt-color-ui-white)',
  },
  quickStart: {
    gap: '1rem',
  },

  chatStarted: {
    gap: '3rem',
  },
  chatcontainer: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(6),
    paddingRight: theme.spacing(14),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    ...scrollbarStyles(theme),
  },
  compactChatcontainer: {
    padding: '24px 24px 76px',
    gap: '12px',
  },
  inputFieldContainer: {
    backgroundColor:
      theme.palette?.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray20)'
        : 'var(--xlrt-color-ui-gray90)',

    borderRadius: '.75rem',
    border: 'none',

    '& .xlrt-TextfieldInput': {
      ...scrollbarStyles(theme),
      padding: '0px',
      boxSizing: 'border-box',
      fontSize: '1rem',
    },

    '& .xlrt-TextfieldInputWrapper, & .xlrt-TextfieldInputWrapper:focus-within':
      {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: '1rem',
        padding: '1.125rem 1.875rem',
        backgroundColor: 'transparent',
        borderRadius: 'inherit',
        boxShadow: 'none',
      },
  },
  compactInputFieldContainer: {
    borderRadius: '16px',
    '& .xlrt-TextfieldInputWrapper, & .xlrt-TextfieldInputWrapper:focus-within':
      {
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-end',
        minHeight: '36px',
        height: 'auto',
        padding: '8px 40px 8px 16px',
        boxSizing: 'border-box',
      },
    '& .xlrt-TextfieldInput': {
      display: 'block',
      width: '100%',
      minWidth: 0,
      height: '18px',
      padding: '0 !important',
      margin: 0,
      lineHeight: '18px',
      fontSize: '13px',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      color: theme.palette.text.primary,
      caretColor: theme.palette.text.primary,
      boxSizing: 'border-box',
      '&::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'block',
      },
    },
  },
  multilineInput: {
    '& .xlrt-TextfieldInputWrapper': {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
  },
  disclaimer: {
    position: 'absolute',
    bottom: theme.spacing(3),
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: '0.75rem',
    fontWeight: 400,
    color:
      theme.palette?.mode === 'dark'
        ? 'rgba(158, 158, 158, 0.50)'
        : 'var(--xlrt-color-ui-gray60)',
    userSelect: 'none',
    pointerEvents: 'none',
    zIndex: 1001,
    whiteSpace: 'nowrap',
  },
  compactDisclaimer: {
    bottom: '2px',
    width: 'calc(100% - 32px)',
    fontSize: '8px',
    lineHeight: '12px',
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
  },
}));
